var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.list),function(item,key){return _c('stat-row',{key:key,attrs:{"name":item.name,"value":item.value,"type":item.type,"total":item.total,"final":key >= (_vm.list.length - 1),"mult":_vm.name}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }